const NOTIFY_MESSAGE = 'LOGIN';

/**
 * 複数タブログイン制御ロジック
 */
export const useMultiTabLoginControlLogic = () => {
  const { registerOnmessage, postMessage } = useBroadcastCannel<string>();

  /**
   * 他のタブにログイン通知を行う
   */
  const notifyLogin = () => postMessage(NOTIFY_MESSAGE);

  /**
   * 他タブからのログイン通知を検知し、ストア情報の破棄とログイン画面への強制遷移させる処理を登録する
   */
  const onLoggedInByOtherTabs = () => {
    registerOnmessage((message: string) => {
      if (message === NOTIFY_MESSAGE) {
        const { isLoggedIn } = useLoginUserStore();
        const { resetStore } = useAuth('0-00');
        if (isLoggedIn()) {
          resetStore();
          useRouter().push('/login');
        }
      }
    });
  };

  return {
    notifyLogin,
    onLoggedInByOtherTabs,
  };
};
